import {
  Control,
  Controller,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import {
  CreateProductFormSchemaType,
  generateNote,
  useGenerateDetailTitle,
  useMaterialCascaderOptions,
} from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Cascader } from 'antd';
import { useCallback } from 'react';
import { DefaultOptionType } from 'types/base';
import getCascaderFilter from 'utils/getCascaderFilter';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';

const ProductMaterial = ({
  control,
  setValue,
}: {
  control: Control<CreateProductFormSchemaType>;
  setValue: UseFormSetValue<CreateProductFormSchemaType>;
}) => {
  const { hardwareSelectOptions } = useAppSelector(selectGlobalInfo);
  const { generateDetailTitle } = useGenerateDetailTitle(control);

  const { firstLevelId, materialCascaderOptions } =
    useMaterialCascaderOptions(control);

  const hardware = useWatch({
    control,
    name: 'hardware',
  });

  const CascaderFilter = useCallback(
    (inputValue: string, path: DefaultOptionType[]) =>
      getCascaderFilter(inputValue, path),
    []
  );

  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.material)}:</FormLabel>
      <Controller
        name="material"
        control={control}
        render={({ field }) => {
          return (
            <Cascader
              {...field}
              className="w-full"
              showSearch={{ filter: CascaderFilter }}
              options={materialCascaderOptions}
              multiple
              placeholder={
                firstLevelId
                  ? i18n.t(LOCALS.please_select)
                  : i18n.t(LOCALS.please_select_category_first)
              }
              onChange={(value) => {
                field.onChange(value);

                const material = value.map((d) => d.map((d) => d.toString()));
                const note = generateNote(
                  material,
                  hardware,
                  materialCascaderOptions,
                  hardwareSelectOptions
                );
                setValue('note', note);

                const detailTitle = generateDetailTitle({
                  material,
                });
                setValue('detailTitle', detailTitle);

                const flatMaterial = material.flat();
                // 包含稀有皮材质则禁用facebook
                setValue(
                  'facebookEnabled',
                  flatMaterial.length
                    ? flatMaterial.includes('exotic-skin')
                      ? 0
                      : 1
                    : 0
                );
              }}
            />
          );
        }}
      />
    </div>
  );
};

export default ProductMaterial;
